import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  summaryCardTitle: {
    id: 'qK56Ec',
    defaultMessage: 'Inventory Sync Details',
    description: 'Title of the card summarizing how one product syncs its stock to selling channels',
  },
  currentInStockLabel: {
    id: 'VUPzlA',
    defaultMessage: 'Current ‘In Stock’ to Sync:',
    description:
      'Label for the consolidated sellable quantity the API reports for this product. The quantity is computed server side and is never derived in the client from on hand and committed counts',
  },
  lastUpdatedLabel: {
    id: 'e43xu5',
    defaultMessage: 'Last updated:',
    description: 'Label for the last time any source connection refreshed the stock counts behind this figure',
  },
  configurationAside: {
    id: 'OGqQ24',
    defaultMessage: 'To select your inventory sources and available targets, {link}.',
    description: 'Body copy pointing the user to the account-level inventory sync settings page',
  },
  configurationLink: {
    id: 'qFzCbj',
    defaultMessage: 'edit your inventory sync configuration',
    description: 'Link text that opens the account-level inventory sync settings page',
  },
  loadErrorMessage: {
    id: '0KkLqN',
    defaultMessage: 'We could not load the inventory sync details for this product.',
    description: 'Error shown when the connections or per-product sync details fail to load',
  },
  loadErrorRetry: {
    id: 'crrFX4',
    defaultMessage: 'Try again',
    description: 'Button that retries loading the inventory sync details for this product',
  },
  noSkuMessage: {
    id: 'cDlxv0',
    defaultMessage: 'Save this product with a SKU to configure Inventory Sync.',
    description: 'Shown instead of the sync table when the product has no SKU yet',
  },
  notConfiguredTitle: {
    id: 'RJvTkK',
    defaultMessage: 'Inventory Sync not configured',
    description: 'Title of the empty state shown when the account has no inventory sync connections',
  },
  notConfiguredDescription: {
    id: '31MTeR',
    defaultMessage: 'Select the selling channels that should receive your consolidated stock counts, then choose how and when they sync.',
    description: 'Description of the empty state shown when the account has no inventory sync connections',
  },
  notConfiguredButton: {
    id: '2S/3bS',
    defaultMessage: 'Set up Inventory Sync',
    description: 'Button that opens the account-level inventory sync settings page from the empty state',
  },
  noTargetsNote: {
    id: 'UEkx8f',
    defaultMessage: 'None of these connections is selected as a sync target, so this product is not syncing anywhere yet.',
    description: 'Note above the table when the account has connections but none of them is a sync target',
  },
});
